import {useState} from "react";
import {Button, ButtonProps, useNotify, useRecordContext, useRefresh} from "react-admin";
import SyncIcon from "@material-ui/icons/Sync";
import {client} from "../../dataProvider";
import {generateError} from "../../shared/utils";

export const SyncPaymentScheduleButton = (props: ButtonProps) => {
    const record = useRecordContext();
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = useState(false);

    if (!record || record.invoice_type !== "P") return null;

    const handleClick = async () => {
        if (!window.confirm(
            "Aggiornare gli importi dello scadenzario al totale salvato della fattura? " +
            "Le date rimangono invariate. Se ci sono più rate, il totale viene ripartito in parti uguali."
        )) return;
        setLoading(true);
        try {
            await client(`invoices/${record.id}/sync_payment_schedule`, {method: "POST"});
            notify("Importi dello scadenzario aggiornati", "info");
            refresh();
        } catch (error) {
            generateError(error, notify);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            {...props}
            label="Aggiorna importi scadenzario"
            disabled={props.disabled || loading || record.status === "P" || record.status === "PP"}
            onClick={handleClick}
        >
            <SyncIcon />
        </Button>
    );
};
